import React from "react";

import { Flex } from "@olist/design-system";

import { CustomReactMarkdowm } from "./custom-react-markdowm";

export function TypingMarkdown({
  // cps = 28,
  // isAlreadyRender,
  // isLast,
  text,
  theme,
}: {
  text: string;
  // cps?: number;
  theme?: "light" | "dark";
  // isLast: boolean;
  // isAlreadyRender?: boolean;
}) {
  // const [current, setCurrent] = useState(0);

  // useEffect(() => {
  //   let i = 0;
  //   const id = setInterval(() => {
  //     i += 1;
  //     setCurrent(i);
  //     if (i >= text.length) clearInterval(id);
  //   }, 1000 / cps);

  //   return () => clearInterval(id);
  // }, [text, cps]);

  // const message = useMemo(() => {
  //   if (isAlreadyRender) return text;
  //   if (isLast) return text.slice(0, current);
  //   return text;
  // }, [text, current, isLast, isAlreadyRender]);

  return (
    <Flex
      flexDirection="column"
      gap="stack.1xsmall"
      style={{ whiteSpace: "pre-wrap", maxWidth: "500px" }}
    >
      <CustomReactMarkdowm message={text} theme={theme} />
    </Flex>
  );
}
